import api from '@/api';

export default {
    // ── 레거시: 이메일 전용 문의 발송 (구 문의하기 — 보존) ──────────
    // eslint-disable-next-line no-unused-vars
    sendEmail ({ commit }, inquery) {
        console.log('action! inquery', inquery);
        // https://test.lecos.co.kr/api/v1/ContactUsByEmail
        return api.post('/ContactUsByEmail', inquery, {
            headers: {
                'Accept-Language': inquery.lang
            },
        });
    },

    // ── 도입 문의 접수 (§3.2) ───────────────────────────────────────
    // payload: { companyName, contactName, position, phone, email, industryType,
    //            description, businessName, introNeeds[], intent, agreePrivacy }
    // 경로(홈페이지)·개인정보 동의 시각은 서버가 자동 세팅(§4.2/§7). JSON 전송.
    // eslint-disable-next-line no-unused-vars
    async submitIntroInquiry ({ commit }, payload) {
        const res = await api.post('/InquiryIntros', payload);
        // 공통 응답: { resultCode, message, data: { id, saved } }
        return res.data;
    },

    // ── 이용(플랫폼 사용) 문의 접수 (§3.3) ──────────────────────────
    // payload: { role, contactName, phone, email, description,
    //            companyName, publisherName, badgeName, walletStatus,
    //            agreePrivacy, files[] }
    // 첨부파일이 있어 multipart/form-data로 전송(§6.3). 활성 역할 데이터만 전달된다.
    // eslint-disable-next-line no-unused-vars
    async submitUsageInquiry ({ commit }, payload) {
        const fd = new FormData();
        fd.append('role', payload.role ?? '');
        fd.append('contactName', payload.contactName ?? '');
        fd.append('phone', payload.phone ?? '');
        fd.append('email', payload.email ?? '');
        fd.append('agreePrivacy', payload.agreePrivacy ? 'true' : 'false');
        fd.append('website', payload.website ?? '');   // 허니팟(스팸 봇 차단)

        // 선택 입력값은 값이 있을 때만 전송
        if (payload.description)   fd.append('description', payload.description);
        if (payload.companyName)   fd.append('companyName', payload.companyName);     // 발행자
        if (payload.publisherName) fd.append('publisherName', payload.publisherName); // 수령자
        if (payload.badgeName)     fd.append('badgeName', payload.badgeName);         // 수령자
        if (payload.walletStatus)  fd.append('walletStatus', payload.walletStatus);   // 수령자

        // 첨부파일(File[]) — 백엔드 List<IFormFile> Files 바인딩 (키: files)
        (payload.files ?? []).forEach((file) => fd.append('files', file));

        // Content-Type은 브라우저가 multipart 경계(boundary)와 함께 자동 설정 → 수동 지정하지 않음
        const res = await api.post('/InquiryUsages', fd);
        return res.data;
    },
};
